import { render } from "./HotspotDownload.vue?vue&type=template&id=42af6c5c&scoped=true&ts=true"
import script from "./HotspotDownload.vue?vue&type=script&lang=ts"
export * from "./HotspotDownload.vue?vue&type=script&lang=ts"

import "./HotspotDownload.vue?vue&type=style&index=0&id=42af6c5c&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42af6c5c"]])

export default __exports__